import { Reveal } from "./Reveal";

const steps = [
  {
    num: "01",
    title: "A real conversation",
    copy: "Reach out and tell us what's going on. We'll sit down together — in Greensboro or by video anywhere in the U.S. It costs you nothing.",
  },
  {
    num: "02",
    title: "Godly guidance",
    copy: "Straightforward, scripture-rooted coaching for your exact situation. We're honest about what it takes, because we've lived it.",
  },
  {
    num: "03",
    title: "Practice at home",
    copy: "You leave with homework — real steps and practices to put into place. Couples who do the work see the change.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 lg:py-32" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] text-[#8A5A44] mb-4">04 — The journey</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#2C2A28] max-w-2xl">
          Simple on purpose. <em className="italic text-[#8A5A44]">Hard work</em> by design.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14 mt-20 relative">
        <div className="hidden md:block absolute top-9 left-[16%] right-[16%] h-px bg-[#E6DFD5]" aria-hidden="true" />
        {steps.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12}>
            <div className="relative" data-testid={`journey-step-${s.num}`}>
              <div className="w-[72px] h-[72px] rounded-full bg-[#F3EFEA] border border-[#E6DFD5] flex items-center justify-center relative z-10">
                <span className="font-serif-display text-2xl font-semibold text-[#8A5A44]">{s.num}</span>
              </div>
              <h3 className="font-serif-display text-2xl md:text-3xl font-medium text-[#2C2A28] mt-8">
                {s.title}
              </h3>
              <p className="text-[#5C5854] leading-relaxed font-light mt-4">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
